import { Box, Stack, Typography, Link } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  JourneyWrapper,
  JourneyWrapperRight,
  JourneyWrapperLeft,
  ThankyouDetail,
} from "./thanyou.style";
import Feedback from "./feedback";

const ThankYouPharmacy = () => {
  const { id, businessName, directorName, directorPhone, directorEmail } = useParams();

  return (
    <>
      <JourneyWrapper>
        <JourneyWrapperRight style={{ background: "#FEF4F8" }}>
          <div className="logo">
            <img src={"/img/newbrand/credilinqLogoNewLight.svg"} />
          </div>
          <div className="contentMid">
            <h1>Thank you for your Application</h1>
            <div>
              <img src={"/img/newbrand/ThankYouIllu.svg"} />
            </div>
            <p style={{ maxWidth: "510px" }}>
              We have received your application and will reach out to you at{" "}
              <Link>{directorEmail}</Link> within 2 business days
            </p>
            <ThankyouDetail>
              <li>
                <Box className="left">Application ID</Box>
                <Box className="right">{id}</Box>
              </li>
              <li>
                <Box className="left">Company Name</Box>
                <Box className="right">{businessName}</Box>
              </li>
              <li>
                <Box className="left">Director Name</Box>
                <Box className="right">{directorName}</Box>
              </li>
              <li>
                <Box className="left">Director Phone</Box>
                <Box className="right">{directorPhone}</Box>
              </li>
            </ThankyouDetail>
          </div>
          <div className="contentBottom">
            <p>Contact Support</p>
            <ul>
              <li>
                <img src={"/img/newbrand/mail.svg"} />
                <Link href="mailto:contact@credilinq.ai">
                  contact@credilinq.ai
                </Link>
              </li>
              <li>|</li>
              <li>
                <img src={"/img/newbrand/whatsup.svg"} />
                <span style={{ color: '#ed0057' }}>{`+61 488779939`}</span>
              </li>
            </ul>
          </div>
        </JourneyWrapperRight>
        {/* <JourneyWrapperLeft>
          <div className="content">
            <Feedback />
          </div>
        </JourneyWrapperLeft> */}
      </JourneyWrapper>
    </>
  );
};

export default ThankYouPharmacy;
